export enum ContentTypes {
  IMAGE_TYPE = 'Image',
  PDF_TYPE = 'PDF',
  DOC_TYPE = 'Doc',
  VIDEO_TYPE = 'Video',
  AUDIO_TYPE = 'Audio',
  UNSUPPORTED_TYPE = 'None',
}
